import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BrandsListComponent } from './pages/brands-list/brands-list.component'
import { SharedModule } from 'src/app/shared/shared.module'
import { StoreRoutingModule } from './store-routing.module'
import { BrandsTableComponent } from './components/brands-table/brands-table.component'
import { CategoriesTableComponent } from './components/categories-table/categories-table.component'
import { CategoriesListComponent } from './pages/categories-list/categories-list.component'
import { AddEditBrandComponent } from './components/add-edit-brand/add-edit-brand.component'
import { StoreProfileDeliveryInfoComponent } from './components/store-profile-delivery-info/store-profile-delivery-info.component'
import { MatExpansionModule } from '@angular/material/expansion'
import { StoreProfileInformationComponent } from './components/store-profile-information/store-profile-information.component'
import { OrderDetailsComponent } from './pages/order-details/order-details.component'
import { OrderListComponent } from './pages/order-list/order-list.component'
import { OrdersTableComponent } from './components/orders-table/orders-table.component'
import { OrdersFilterComponent } from './components/orders-filter/orders-filter.component';
import { UpdateOrderStatusPopupComponent } from './components/update-order-status-popup/update-order-status-popup.component';
import { HistoryStatusPopupComponent } from './components/history-status-popup/history-status-popup.component'
@NgModule({
	declarations: [
		BrandsListComponent,
		BrandsTableComponent,
		CategoriesTableComponent,
		CategoriesListComponent,
		AddEditBrandComponent,
		StoreProfileDeliveryInfoComponent,
		StoreProfileInformationComponent,
		OrderListComponent,
		OrdersTableComponent,
		OrdersFilterComponent,
		OrderDetailsComponent,
  UpdateOrderStatusPopupComponent,
  HistoryStatusPopupComponent,
	],
	imports: [CommonModule, StoreRoutingModule, SharedModule, MatExpansionModule],
	exports: [
		StoreProfileDeliveryInfoComponent,
		StoreProfileInformationComponent,
	],
})
export class StoreModule {}
